import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import { useMotiveMobileStyles } from '../../../mis-compras/components/report-issue-view/mobile/styles';
import { notProductIssueMapper } from '../../../../../helpers/IssueMapper';

const MotiveMobileMapper = ({ ...props }) => {
  const { title, motiveId } = props;
  const location = useLocation();
  const classes = useMotiveMobileStyles();

  return (
    <Link
      className={classes.link}
      to={{
        pathname: notProductIssueMapper(motiveId),
        state: { prevRoute: location.pathname },
      }}
    >
      <Box className={classes.boxMotive}>
        <Typography className={classes.title}>{title}</Typography>
        <IconButton>
          <KeyboardArrowRightIcon />
        </IconButton>
      </Box>
    </Link>
  );
};

MotiveMobileMapper.propTypes = {
  title: PropTypes.string,
  motiveId: PropTypes.string,
};

export default MotiveMobileMapper;
